import { createFileRoute, useLocation } from '@tanstack/react-router';
import { Spinner } from '@workspace/ui/components/spinner';
import { useEffect } from 'react';

import { useAuth } from '~/auth/use-auth';
import { m } from '~/paraglide/messages.js';

export const Route = createFileRoute('/_public/oauth/')({
  validateSearch: (
    search: Record<string, string>,
  ): { access_token?: string } => {
    return {
      access_token: search.access_token,
    };
  },
  component: OAuthPage,
});

function OAuthPage() {
  const { setAccessToken } = useAuth();
  const { search } = useLocation();

  useEffect(() => {
    const token = search.access_token;
    if (token) {
      setAccessToken(token);
    }
  }, [setAccessToken, search]);

  return <Spinner message={m['common.thinking']()} />;
}
